<template>
  <svg class="_component-icon-svg" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" :style="componentStyle" @click="$emit('click')">
    <g clip-path="url(#clip0_287_407)">
      <path
        d="M10 11C12.7614 11 15 8.76142 15 6C15 3.23858 12.7614 1 10 1C7.23858 1 5 3.23858 5 6C5 8.76142 7.23858 11 10 11Z"
        :stroke="strokeColor"
        stroke-width="2"
      />
      <path
        d="M10 32C14.9706 32 19 27.9706 19 23C19 18.0294 14.9706 14 10 14C5.02944 14 1 18.0294 1 23C1 27.9706 5.02944 32 10 32Z"
        :stroke="strokeColor"
        stroke-width="2"
      />
    </g>
    <defs>
      <clipPath id="clip0_287_407">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
</template>

<script>
/**
 * @module User 关闭组件
 */
export default {
  name: 'User',
  /**
   * @prop {String} color 颜色
   */
  props: {
    color: {
      type: String,
      default: 'none'
    }
  },
  /**
   * @member {Object} componentStyle 组件style
   */
  computed: {
    componentStyle() {
      return {
        fill: this.color
      };
    },
    strokeColor() {
      return this.color === 'none' ? '#494A4D' : this.color;
    }
  }
};
</script>
<style lang="less" scoped src="./index.less"></style>
